module.exports = __webpack_public_path__ + "img/图片10.f3b99e11.png";